import React from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import "./index.scss";

const { Title } = Typography;

interface ChatSidebarHeaderProps {
  title: string;
  handleBackClick: () => void;
  disabled?: boolean
}

const ChatSidebarHeader: React.FC<ChatSidebarHeaderProps> = ({
  handleBackClick,
  title,
  disabled
}) => {
  return (
    <div className="chat-sidebar-header">
      <ArrowLeftOutlined disabled={disabled} className="back-icon" onClick={handleBackClick} />
      <Title className="title">{title}</Title>
    </div>
  );
};

export default ChatSidebarHeader;
